module.exports = __webpack_public_path__ + "static/media/sort_down.79d720e3.svg";